var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 teste"},[_c('b-icon',{staticClass:"mb-4",attrs:{"icon":"lock","aria-hidden":"true","scale":"4"}}),_vm._m(0),_c('p',[_vm._v("contate pessoa responsável")])],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"mt-2"},[_c('strong',[_vm._v("Acesso Negado.")])])
}]

export { render, staticRenderFns }